import { Combobox as HeadlessCombobox } from '@headlessui/react'
import { useState, useEffect } from 'react'
import { FaCheck, FaChevronDown } from 'react-icons/fa'

export function Combobox({
    options = [],
    selectedOption = null,
    onSelect = () => {},
    placeholder = 'Select an option',
    className = '',
    disabled = false,
    searchable = true,
}) {
    const [query, setQuery] = useState('')
    const [selected, setSelected] = useState(selectedOption)

    // Update internal state when prop changes
    useEffect(() => {
        setSelected(selectedOption)
    }, [selectedOption])

    const filteredOptions =
        query === ''
            ? options
            : options.filter(option => option.label.toLowerCase().includes(query.toLowerCase()))

    const handleSelect = option => {
        setSelected(option)
        onSelect(option)
        if (!searchable) setQuery('')
    }

    return (
        <div className={`relative ${className}`}>
            <HeadlessCombobox value={selected} onChange={handleSelect} disabled={disabled}>
                {({ open }) => (
                    <>
                        <div className='relative'>
                            {searchable ? (
                                <HeadlessCombobox.Input
                                    className='w-full py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 disabled:opacity-50'
                                    displayValue={option => option?.label || ''}
                                    onChange={event => setQuery(event.target.value)}
                                    placeholder={placeholder}
                                />
                            ) : (
                                <HeadlessCombobox.Button className='w-full py-2 pl-3 pr-10 text-sm leading-5 text-left text-gray-900 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 disabled:opacity-50'>
                                    <span className='block truncate'>
                                        {selected?.label || placeholder}
                                    </span>
                                </HeadlessCombobox.Button>
                            )}
                            <HeadlessCombobox.Button className='absolute inset-y-0 right-0 flex items-center pr-2'>
                                <FaChevronDown
                                    className={`w-5 h-5 text-gray-400 transition-transform ${
                                        open ? 'transform rotate-180' : ''
                                    }`}
                                />
                            </HeadlessCombobox.Button>
                        </div>

                        <HeadlessCombobox.Options className='absolute z-10 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black/5 focus:outline-none sm:text-sm'>
                            {filteredOptions.length === 0 && query !== '' ? (
                                <div className='relative px-4 py-2 text-gray-700 cursor-default select-none'>
                                    Nothing found
                                </div>
                            ) : (
                                filteredOptions.map(option => (
                                    <HeadlessCombobox.Option
                                        key={option.id}
                                        value={option}
                                        className={({ active }) =>
                                            `relative cursor-default select-none py-2 pl-10 pr-4 ${
                                                active
                                                    ? 'bg-yellow-500 text-white'
                                                    : 'text-gray-900'
                                            }`
                                        }
                                    >
                                        {({ selected, active }) => (
                                            <>
                                                <span
                                                    className={`block truncate ${
                                                        selected ? 'font-medium' : 'font-normal'
                                                    }`}
                                                >
                                                    {option.label}
                                                </span>
                                                {selected && (
                                                    <span
                                                        className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                                                            active
                                                                ? 'text-white'
                                                                : 'text-yellow-500'
                                                        }`}
                                                    >
                                                        <FaCheck className='w-5 h-5' />
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    </HeadlessCombobox.Option>
                                ))
                            )}
                        </HeadlessCombobox.Options>
                    </>
                )}
            </HeadlessCombobox>
        </div>
    )
}
